import React from "react";
import styled from "@emotion/styled";

export function Main({ children }: { children: React.ReactNode }) {
  return <MainSection>{children}</MainSection>;
}

const MainSection = styled("main")`
  height: 100%;
`;
